import { Component, OnInit, Output, EventEmitter, Input } from "@angular/core"; 
import { FormBuilder, FormGroup } from "@angular/forms"; 
import { environment } from "src/environments/environment"; 
import { NgbModal } from "@ng-bootstrap/ng-bootstrap"; 
import { ImageEditorComponent } from "../image-editor/image-editor.component"; 
import * as moment from "moment"; 
import { AlertService, CommonService, UserService, LoaderService, ModalWrapperService } from "src/app/services"; 
import { PrivMaskGuard } from "src/app/guards"; 
import { AccCategoryE, EditRxE, RefillRxE, RxEntryE } from "src/app/models"; 
import { MsgConfig } from "src/app/app.messages"; 
import { Subject, timer } from "rxjs"; 
import { takeUntil } from "rxjs/operators"; 
import Dynamsoft from "dwt"; 
@Component({
    selector: "app-scanner-util",
    templateUrl: "./scanner-util.component.html",
    standalone: false
})
export class ScannerUtilComponent implements OnInit {
    DWObject;
    imageOutput: any;
    imgURL: string | ArrayBuffer;
    scannedFiles = [];
    respArray = [];
    ScannerFG: FormGroup;
    imageTypeDropdowns: any[];
    scannerSources: any[];
    DWTLicenseKey: any;
    unsubscribe$: Subject<void> = new Subject();
    maxRetries = 5;
    retryCount = 0;
    @Input()
    set ScanMode(mode: any) {
        this.scanMode = mode;
    }
    ScannerDynamsoftIsOutDated = MsgConfig.Scanner_DynamsoftIsOutDated;
    get isDynamsoftIsOutDated() {
        return this._commonServ.isDynamsoftIsOutDated;
    }

    @Input()
    set ShowUi(data: any) {
        this.showUi = data;
    }
    @Input() rxType: any;
    @Input() isFromLogin: any;

    @Output()
    ScannedFile = new EventEmitter();
    showImageEditor: boolean;
    imageFile: File;

    @Output()
    ScannedFileStream = new EventEmitter();

    scanMode: any;
    showUi = true;
    pendingScan = false;

    constructor(private _fb: FormBuilder, private _modalService: ModalWrapperService,private _commonServ:CommonService,
        private _userservice: UserService,private _privMask: PrivMaskGuard,private _alertSvc: AlertService,
        private _loaderServ: LoaderService) {
    }

    ngOnInit() {
        this.createFG();
        if (this.isFromLogin) {
            this.DynamsoftInstallationCheck()
        } else {
            this.DWObject = this._commonServ.dynamsoftValue;
            if (this.DWObject) {
                this.Dynamsoft_OnReady()
            } else {
                this._commonServ.Dynamsoft$
                    .pipe(takeUntil(this.unsubscribe$))
                    .subscribe((dwObject) => {
                        if (dwObject) {
                            this.DWObject = dwObject;
                            this.Dynamsoft_OnReady();
                        }
                    });
            }
        }
    }

    DynamsoftInstallationCheck() {
        const licenseDecryptValue = this._commonServ.DecryptData(localStorage.getItem('SfaxEncryptionVector'));
        if (!localStorage.getItem("DWTLicensekey")) {
            this._userservice.getWijimoAndDWTDWTLicenseKey()
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe({
                next:(resp) => {
                    if (resp) {
                        this.retryCount = 0;
                        this.DWTLicenseKey = resp.find(obj => obj.KeyName === "DWTLicenseKey");
                        // Dynamsoft.WebTwainEnv.ProductKey = this.DWTLicenseKey.KeyValue;
                        if (this.DWTLicenseKey && this.DWTLicenseKey.KeyValue) {
                            localStorage.setItem("DWTLicensekey", this.DWTLicenseKey.KeyValue);
                        }
                        Dynamsoft.DWT.ProductKey = this._commonServ.DecryptData(localStorage.getItem("DWTLicensekey"), false, licenseDecryptValue);
                        // Dynamsoft.DWT.ProductKey = "t0200EQYAAHtRHZhYu9O8sU8K35tP7X5JK7XaogbPcoRmUEiW6vBLB7iNYlVnPt96Q4GbLQ0YDteTNw5YwH+akZaDvncVSwCLx5lTOji1vTOI2zrZwSm3nMAYPod42iaM2wbICkxxsu91+AHMgbiWAzDbvffMkABSA7QCaG0NrAHFXfjkS5687fc/p9cOtOSUDk5t78wLpI2THZxyy+kLxA0wi9/tEguE+c1JAKkBWgTCvEShQHAEpAZoEZgPVSwJADcYWIr7AGWbPgI="
                    }
                }, error:(err) => {
                    if ((err.status === 403 || err.status === 401) && this.retryCount < this.maxRetries) {
                        this.retryCount++;
                            timer(500).subscribe(() => {
                                this.DynamsoftInstallationCheck();
                            });
                    } else if (this.retryCount >= this.maxRetries) {
                        this._alertSvc.error("Failed to retrieve scanner license key after multiple attempts. Please refresh and try again.");
                    } else {
                        this._alertSvc.error("Failed to retrieve scanner license key. Please try again.");
                    }
                }
            });
        } else {
            Dynamsoft.DWT.ProductKey = this._commonServ.DecryptData(localStorage.getItem("DWTLicensekey"), false, licenseDecryptValue);
            // Dynamsoft.DWT.ProductKey = "t0200EQYAAHtRHZhYu9O8sU8K35tP7X5JK7XaogbPcoRmUEiW6vBLB7iNYlVnPt96Q4GbLQ0YDteTNw5YwH+akZaDvncVSwCLx5lTOji1vTOI2zrZwSm3nMAYPod42iaM2wbICkxxsu91+AHMgbiWAzDbvffMkABSA7QCaG0NrAHFXfjkS5687fc/p9cOtOSUDk5t78wLpI2THZxyy+kLxA0wi9/tEguE+c1JAKkBWgTCvEShQHAEpAZoEZgPVSwJADcYWIr7AGWbPgI="

        }
        Dynamsoft.DWT.ResourcesPath = 'assets/dwt-resources';
        Dynamsoft.DWT.AutoLoad = false;
        Dynamsoft.DWT.Containers = [
            {
                ContainerId: "dwtcontrolContainer",
                Width: "100px",
                Height: "100px",
            },
        ];

        Dynamsoft.DWT.RegisterEvent("OnWebTwainReady", () => {
            this.Dynamsoft_OnReady();
        });
        Dynamsoft.DWT.OnWebTwainPreExecute = function() {};
        Dynamsoft.DWT.OnWebTwainPostExecute = function() {};

        Dynamsoft.DWT.Load();
                Dynamsoft.DWT.RegisterEvent("OnWebTwainError", (errorCode, errorString) => {
            if(errorCode?.code === -2207) {
                this.ScannerDynamsoftIsOutDated = MsgConfig.Scanner_DynamsoftIsOutDated;
                this._commonServ.isDynamsoftIsOutDated.set(true);
                
            } else if(errorCode?.code === -2800) {
                this._commonServ.isDynamsoftIsOutDated.set(true);
            } else {
                this._commonServ.isDynamsoftIsOutDated.set(false);
            }
        });
        this.pageonload();
    }

    verifyInstallation() {
        // Unload existing Dynamsoft instance if any
        if (Dynamsoft && Dynamsoft.DWT) {
            try {
                Dynamsoft.DWT.Unload();
            } catch (e) {
            }
        }
        
        // Reset DWObject so it gets re-acquired in Dynamsoft_OnReady
        this.DWObject = null;
        
        // Re-initialize Dynamsoft
        // This will either show download dialog if not installed, or load successfully
        this.DynamsoftInstallationCheck();
    }

    async checkScannerCompatibility(): Promise<'ok' | 'outdated'> {
        try {
            const controller = new AbortController();
            const timeoutId = setTimeout(() => controller.abort(), 2000);
            
            const response = await fetch("http://127.0.0.1:18622/", { 
                signal: controller.signal,
                mode: 'cors'
            });
            clearTimeout(timeoutId);
            
            return 'ok';
        } catch (error) {
            try {
                const controller = new AbortController();
                const timeoutId = setTimeout(() => controller.abort(), 2000);
                
                await fetch("http://127.0.0.1:18625/", { 
                    signal: controller.signal,
                    mode: 'cors'
                });
                
                clearTimeout(timeoutId);
                return 'outdated';  
            } catch { 
                const installedVersion = this.getInstalledWebTwainServiceVersion();
                if (installedVersion) {
                    const majorVersion = parseInt(installedVersion.split('.')[0]);
                    return majorVersion >= 19 ? 'ok' : 'outdated';
                }
                return 'outdated'; 
            }
        }
    }
    getInstalledWebTwainServiceVersion() {
            if (
                (window as any).Dynamsoft &&
                (window as any).Dynamsoft.DWT &&
                (window as any).Dynamsoft.DWT.ServerVersionInfo
            ) {
                return (window as any).Dynamsoft.DWT.ServerVersionInfo;
            }
            return null;
    }
    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    createFG() {
        let scannResolutionSetting = this._commonServ.getSetttingValue("DmsSettings", "Scanned_Document_Resolution");
        let imageType = this._commonServ.getSetttingValue("DmsSettings", "Default_Scanning_Image_Type");
        this.ScannerFG = this._fb.group({
            scannerSource: [0],
            pixelType: [imageType == "1" ?  Dynamsoft.DWT.EnumDWT_PixelType.TWPT_GRAY : Dynamsoft.DWT.EnumDWT_PixelType.TWPT_RGB],
            resolution: [scannResolutionSetting ? +scannResolutionSetting : null],
            duplex: [false]
        });
    }

    startScan() {
        let fgValue = this.ScannerFG.value;
        if (this.rxType == "nr" && !this._privMask.canActivate(AccCategoryE.RxEntry, RxEntryE.ScanADocument)) {
            this._alertSvc.error(MsgConfig.NO_PRIVS_ACCESS);
        } else if (this.rxType == "er" && !this._privMask.canActivate(AccCategoryE.EditRx, EditRxE.ScanADocument)) {
            this._alertSvc.error(MsgConfig.NO_PRIVS_ACCESS);
        } else if (this.rxType == "rf" && !this._privMask.canActivate(AccCategoryE.RefillRx, RefillRxE.ScanADocument)) {
            this._alertSvc.error(MsgConfig.NO_PRIVS_ACCESS);
        } else {
            if (this.DWObject) {
                if (!this.DWObject.SourceCount || this.DWObject.SourceCount <= 0) {
                    this._alertSvc.error("No scanners found. Please connect a scanner and try again.");
                    return;
                }
                this._loaderServ.display(true);
                this.DWObject.RegisterEvent(
                    "OnPostTransfer",
                    () => {
                        this.processSingleImage();
                    }
                );

                this.DWObject.RegisterEvent(
                    "OnPostAllTransfers",
                    () => {
                        this.DWObject.CloseSource();
                        this._loaderServ.display(false);
                    }
                );
                // Ensure loader is hidden and source is closed on acquire failures
                this.DWObject.RegisterEvent(
                    "OnAcquireImageFailure",
                    (errorCode, errorString) => {
                        if (this.DWObject) {
                            this.DWObject.CloseSource();
                        }
                        this._loaderServ.display(false);
                    }
                );
                // Ensure loader is hidden on transfer errors
                this.DWObject.RegisterEvent(
                    "OnTransferError",
                    (errorCode, errorString) => {
                        if (this.DWObject) {
                            this.DWObject.CloseSource();
                        }
                        this._loaderServ.display(false);
                    }
                );
                // Ensure loader is hidden if user cancels all transfers
                this.DWObject.RegisterEvent(
                    "OnCancelAllTransfers",
                    () => {
                        if (this.DWObject) {
                            this.DWObject.CloseSource();
                        }
                        this._loaderServ.display(false);
                    }
                );
                try {
                    this.DWObject.SelectSourceByIndex(this.ScannerFG.value.scannerSource);
                    if (this.DWObject.ErrorCode !== 0) {
                        this._alertSvc.error("Failed to select scanner source. Please check your scanner connection.");
                        this._loaderServ.display(false);
                        return;
                    }
                    this.DWObject.OpenSource();
                    if (this.DWObject.ErrorCode !== 0) {
                        this._alertSvc.error("Failed to open scanner source. Please check your scanner connection.");
                        this._loaderServ.display(false);
                        return;
                    }
                    this.DWObject.IfShowProgressBar = false;
                    this.DWObject.IfShowCancelDialogWhenImageTransfer = false;
                    this.DWObject.IfShowFileDialog = false;
                    this.DWObject.IfShowIndicator = false;
                    this.DWObject.IfShowPrintUI = false;
                    this.DWObject.IfShowUI = false;
                    this.DWObject.PixelType = this.ScannerFG.value.pixelType ? this.ScannerFG.value.pixelType : Dynamsoft.DWT.EnumDWT_PixelType.TWPT_RGB;
                    this.DWObject.Resolution = this.ScannerFG.value.resolution;
                    this.DWObject.IfDuplexEnabled = !!fgValue.duplex;
                    this.DWObject.IfDisableSourceAfterAcquire = true;
                    this.DWObject.TransferMode = Dynamsoft.DWT.EnumDWT_TransferMode.TWSX_NATIVE;
                    this.DWObject.AcquireImage();
                } catch (error) {
                    if (this.DWObject) {
                        this.DWObject.CloseSource();
                    }
                    this._loaderServ.display(false);
                }

            } else {
                this.pendingScan = true;
                this.DynamsoftInstallationCheck();
            }
        }
       
    }
    processSingleImage(): void {
        const count = this.DWObject.HowManyImagesInBuffer;

        if (!count || count < 1) {
            return;
        }

        const index = count - 1;
        const timeStamp = moment().format("YYYYMMDD-HHmmss");

        this.DWObject.ConvertToBlob(
            [index],
            Dynamsoft.DWT.EnumDWT_ImageType.IT_PNG,
            (blob: Blob) => {
                const reader = new FileReader();
                reader.onload = async () => {
                    const dataUrl = reader.result as string;
                    const base64 = dataUrl.split(",")[1];

                    this.imageOutput = base64;

                    this.ScannedFileStream.emit({
                        byteStream: dataUrl,
                        filename: `${timeStamp}.png`,
                        extsn: "png",
                    });
                    const file = this.urlToFile(
                        dataUrl,
                        `${timeStamp}.png`,
                        "image/png"
                    );

                    this.imageFile = file;
                    this.scannedFiles.push(file);
                    this.ScannedFile.emit(file);
                };

                reader.readAsDataURL(blob);
            },
            (errorCode: number, errorString: string) => {
                this.imageOutput = null;
                this.imageFile = null;
                this.imgURL = null;
                console.error("Failed to convert scanned image to blob.", {
                    errorCode,
                    errorString
                });
            }
        );
    }

    clearImages() {
        this.DWObject.RemoveAllImages();
        this.scannedFiles = [];
    }

    printImage2(): void {
        if (!this.imageOutput) return;

        const file = this.urlToFile(
            `data:image/png;base64,${this.imageOutput}`,
            "today.png",
            "image/png"
        );

        this.showTransferedImage(file);
    }

    showTransferedImage(file) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (_event) => {
            this.imgURL = reader.result;
        };
    }

    urlToFile(dataUrl: string, filename: string, mimeType: string): File {
        const base64 = dataUrl.split(",")[1];
        const byteString = atob(base64);

        const byteNumbers = new Array(byteString.length);
        for (let i = 0; i < byteString.length; i++) {
            byteNumbers[i] = byteString.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: mimeType });

        return new File([blob], filename, { type: mimeType });
    }

    printImage(): void {
        const count = this.DWObject.HowManyImagesInBuffer;
        if (!count) return;

        const index = count - 1;

        this.DWObject.ConvertToBlob(
            [index],
            Dynamsoft.DWT.EnumDWT_ImageType.IT_PNG,
            (blob: Blob) => {
                const reader = new FileReader();
                reader.onload = () => {
                    this.imageOutput = (reader.result as string).split(",")[1];
                };
                reader.readAsDataURL(blob);
            },
            () => {
                this.imageOutput = null;
                console.error("Failed to convert image to blob for printing.");
            }
        );
    }

    pageonload() {}

    Dynamsoft_OnReady() {
        const liNoScanner = document.getElementById("pNoScanner");
        if (this.isFromLogin) {
            this.DWObject = Dynamsoft.DWT.GetWebTwain(
                "dwtcontrolContainer"
            );
            if(this.DWObject){
                this._commonServ.isDynamsoftIsOutDated.set(false);
            }
            this._commonServ._Dynamsoft$.next(this.DWObject);
        } else {
            if (!this.DWObject) {
                this.DWObject = Dynamsoft.DWT.GetWebTwain("dwtcontrolContainer");
                if (this.DWObject) {
                    this._commonServ._Dynamsoft$.next(this.DWObject);
                }
            }
            if (this.DWObject) {
                this._commonServ.isDynamsoftIsOutDated.set(false);
                if (this.DWObject.ErrorCode == 0) {
                    this.DWObject.LogLevel = 0;
                    this.DWObject.IfAllowLocalCache = true;
                    this.DWObject.ImageCaptureDriverType = 3;
                }
            
                const vCount = this.DWObject.SourceCount;
                this.scannerSources = [];
                const invalidCharsRegex = /["\\{}]/;
                for (let i = 0; i < vCount; i++) {
                    if (invalidCharsRegex.test(this.DWObject.GetSourceNameItems(i))) {
                    }
                    this.scannerSources.push({
                        Id: i,
                        Name: this.DWObject.GetSourceNameItems(i),
                    });
                }
                this.imageTypeDropdowns = [
                    { Id: Dynamsoft.DWT.EnumDWT_PixelType.TWPT_GRAY, Name: "Gray" },
                    { Id: Dynamsoft.DWT.EnumDWT_PixelType.TWPT_RGB, Name: "RGB" },
                ];
        
                this.DWObject.RegisterEvent(
                    "OnPostTransfer",
                    this.Dynamsoft_OnPostTransfer
                );
                this.DWObject.RegisterEvent(
                    "OnPostLoad",
                    this.Dynamsoft_OnPostLoadfunction
                );
                this.DWObject.RegisterEvent(
                    "OnPostAllTransfers",
                    this.Dynamsoft_OnPostAllTransfers
                );

                if (this.pendingScan) {
                    this.pendingScan = false;
                    this.startScan();
                }
            }
        }
    }

    Dynamsoft_OnPostTransfer = () => {};

    Dynamsoft_OnPostLoadfunction = (path, name, type) => {};
    Dynamsoft_OnPostAllTransfers = () => {
        // this.DWObject.CloseSource();
    }

    editImage() {
        const modelRef = this._modalService.open(ImageEditorComponent, {
            size: "lg",
            keyboard: false,
            backdrop: "static",
            centered : true,
            windowClass: "max-modal-74"
        });
        modelRef.componentInstance.IsFromDocumentQueue = true;
        modelRef.componentInstance.ImageData =
            "data:image/png;base64," + this.imageOutput;
        modelRef.componentInstance.IsPopUpClosed
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((base64) => {
            modelRef.close();
        });
    }
}